import React from 'react'

// Material-UI
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import {
  FiPhone,
  FiSmartphone,
  FiUser,
  FiHome
} from "react-icons/fi"
import './EmergencyContactItem.scss'


function EmergencyContactItem({ emergencyContactItem }) {
  return (
    <div className="App EmergencyContactItem">
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid size={12}>
            <form noValidate autoComplete="off">
              <Grid container>
                <Grid size={12} className="container-field">
                  {emergencyContactItem.name && (
                    <Grid>
                      {<FiUser />} <label className="main-title-label">Name:</label>
                      <Grid className="container-field">
                        <Grid><label> {emergencyContactItem.name} </label></Grid>
                      </Grid>
                    </Grid>
                  )}

                  {emergencyContactItem.cellPhoneNumber && (
                    <Grid>
                      {<FiSmartphone />} <label className="main-title-label">Cell:</label>
                      <Grid className="container-field">
                        <Grid><a href={'tel:' + emergencyContactItem.cellPhoneNumber}> {emergencyContactItem.cellPhoneNumber}</a></Grid>
                      </Grid>
                    </Grid>
                  )}

                  {emergencyContactItem.homePhoneNumber && (
                    <Grid>
                      {<FiPhone />} <label className="main-title-label">Home:</label>
                      <Grid className="container-field">
                        <Grid><a href={'tel:' + emergencyContactItem.homePhoneNumber}> {emergencyContactItem.homePhoneNumber}</a></Grid>
                      </Grid>
                    </Grid>
                  )}

                  {emergencyContactItem.workPhoneNumber && (
                    <Grid>
                      {<FiPhone />} <label className="main-title-label">Work:</label>
                      <Grid className="container-field">
                        <Grid><a href={'tel:' + emergencyContactItem.workPhoneNumber}> {emergencyContactItem.workPhoneNumber}</a></Grid>
                      </Grid>
                    </Grid>
                  )}

                  {emergencyContactItem.livesAtThisLocation && (
                    <Grid>
                      {<FiHome />} <label className="main-title-label">I live here:</label>
                      <Grid className="container-field">
                        <Grid>
                          <label>
                            {emergencyContactItem.livesAtThisLocation ? "Yes" : "No"}
                          </label>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default EmergencyContactItem
